import { useMemo } from 'react'

import { useShopPaymentMethodsQuery } from '../queries/useShopPaymentMethodsQuery'
import { mapPaymentMethods } from '../utils/mapPaymentMethods'

export const useShopPaymentMethods = (
  options?: Parameters<typeof useShopPaymentMethodsQuery>[1],
) => {
  const { shopPaymentMethodsQuery, invalidateShopPaymentMethodsQuery } = useShopPaymentMethodsQuery(
    [],
    options,
  )

  const shopPaymentMethods = useMemo(() => {
    return shopPaymentMethodsQuery.data
      ? mapPaymentMethods(shopPaymentMethodsQuery.data)
      : undefined
  }, [shopPaymentMethodsQuery.data])

  const defaultPaymentMethod = useMemo(
    () => shopPaymentMethods?.find((shopPaymentMethod) => shopPaymentMethod.default),
    [shopPaymentMethods],
  )

  const hasActivePaymentMethod = defaultPaymentMethod && !defaultPaymentMethod.invalid

  return {
    shopPaymentMethods,
    defaultPaymentMethod,
    hasActivePaymentMethod,
    isLoadingShopPaymentMethods: shopPaymentMethodsQuery.isLoading,
    isFetchingShopPaymentMethods: shopPaymentMethodsQuery.isFetching,
    invalidateShopPaymentMethods: invalidateShopPaymentMethodsQuery,
  }
}
